import { rest } from 'msw';

import { getMockUrl } from '../../mocks/getMockUrl';
import { SAMPLE_PDF_URL } from '../customer/checklist/checklist-mocks';

import { ReferenceGuideSection, ReferenceGuideUpload } from './referenceGuides-api';


let referenceGuideSectionID = 4;
let referenceGuideID = 100;

export const mocks = [
    rest.get(getMockUrl('/document/client/referenceGuide'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(referenceGuideSections)
    ))),
    rest.post(getMockUrl('/document/client/referenceGuide'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json({
            ...req.body as ReferenceGuideSection,
            id: `${referenceGuideSectionID++}`,
            files: []
        })
    ))),
    rest.post(getMockUrl('/document/client/referenceGuide/:referenceGuideSectionID'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json({
            id: `${referenceGuideSectionID++}`,
            title: (req.body as ReferenceGuideUpload).title,
            description: (req.body as ReferenceGuideUpload).description,
            sectionID: (req.body as ReferenceGuideUpload).sectionId,
            createdAt: new Date(),
            url: SAMPLE_PDF_URL
        })
    ))),
    rest.put(getMockUrl('/document/client/referenceGuide/:referenceGuideSectionID/:referenceGuideID'), (req, res, ctx) => (res(
        ctx.status(200),
        ctx.json(req.body)
    ))),
    rest.delete(getMockUrl('/document/client/referenceGuide/:referenceGuideSectionID/:referenceGuideID'), (req, res, ctx) => (res(
        ctx.status(200)
    ))),
    rest.delete(getMockUrl('/document/client/referenceGuide/:referenceGuideSectionID'), (req, res, ctx) => (res(
        ctx.status(200)
    )))
];

const referenceGuideSections: ReferenceGuideSection[] = [
    {
        id: '2',
        title: 'Contacts',
        files: [
            {
                id: `${referenceGuideID++}`,
                sectionId: '2',
                title: 'Contacts',
                description: 'Contact sheet for Lendalot',
                createdAt: '2023-04-05T16:18:06.526Z',
                url: 'https://premicorr-demo-investco.s3.amazonaws.com/client/REFERENCE_GUIDE/CONTACTS/Contacts.pdf'
            }
        ]
    },
    {
        id: '3',
        title: 'Lock policy',
        files: [
            {
                id: `${referenceGuideID++}`,
                sectionId: '3',
                title: 'Lock policy',
                url: 'https://premicorr-demo-investco.s3.amazonaws.com/client/REFERENCE_GUIDE/LOCKS/Lock%20Policy.pdf',
                description: 'Lock policy for lendalot',
                createdAt: '2023-06-07T16:18:06.526Z'
            }
        ]
    },
    {
        id: '4',
        title: 'Seller guide',
        files: [
            {
                id: `${referenceGuideID++}`,
                sectionId: '4',
                title: 'Seller guide',
                url: 'https://premicorr-demo-investco.s3.amazonaws.com/client/REFERENCE_GUIDE/SELLERS/Seller%20Guide.pdf',
                description: 'Seller guide for Lendalot',
                createdAt: '2023-06-07T16:18:06.526Z'
            }
        ]
    }
];

